import { useTranslation } from 'react-i18next';
import { createPortal } from 'react-dom';
import { sortModalOverlayStyles, sortModalContainerStyles, sortModalItemStyles, sortModalHeaderStyles } from '../../styles/commonStyles';

function SortModal({ isOpen, onClose, onSelect, selectedOption, options }) {
    const { t } = useTranslation();

    const handleSelect = (key) => {
        onSelect(key);
        onClose();
    };

    const modalContent = isOpen && (
        <>
            <div className={sortModalOverlayStyles} onClick={onClose} />
            <div className={sortModalContainerStyles + (isOpen ? ' translate-y-0' : ' translate-y-full')}>
                <h2 className={sortModalHeaderStyles}>{t('sortControls.title')}</h2>
                <ul className="space-y-2">
                    {Object.entries(options).map(([key, label]) => (
                        <li
                            key={key}
                            className={sortModalItemStyles(selectedOption === key)}
                            onClick={() => handleSelect(key)}
                        >
                            {label}
                        </li>
                    ))}
                </ul>
            </div>
        </>
    );

    return createPortal(modalContent, document.body);
}

export default SortModal;
